import { FuelButton } from '@frete.com/fuel-react';
import React, { FC } from 'react';
import { TShareFreight } from './types';

const ShareFreight: FC<TShareFreight> = ({ handleClick }) => (
  <FuelButton
    onlyIcon
    trailingIcon="share"
    variant="secondary"
    data-testid="share-freight"
    size="medium"
    onClick={handleClick}
  />
);

export default ShareFreight;
